$.guideGallery = function guideGallery(element, options) {
    const defaults = {
        images: '', // image sources (JSON format)
        mainImgID: '', // big image ID
        prevClass: '', // previous text/arrow class
        nextClass: '', // next text/arrow class
        imgIndex: 0, // image position
        positionCounterID: '', // position counter ID
        loaderID: '', // image loader ID
        carouselID: '', // carousel ID
        carouselPrevID: '', // carousel previous arrow ID
        carouselNextID: '', // carousel next arrow ID
        largeImageLink: '', // carousel largeImageLink ID
    };
    const self = this;
    self.options = {};

    const $element = $(element);

    // private method
    function init() {
        self.options = $.extend({}, defaults, options);
        self.options.loader = $(self.options.loaderID);
        self.options.positionCounter = $(self.options.positionCounterID);
        self.options.mainImg = $(self.options.mainImgID);
        self.options.largeImageLink = $(self.options.largeImageLink);

        self.options.thumbs = $('.carouselThumb').each(function carouselThumb(index) {
            $(this).data('imgIndex', index);
        }).on('click', function changeViewingImage(e) {
            e.preventDefault();
            if ($(this)[0].className.indexOf('active') === -1) {
                self.options.imgIndex = $(this).data('imgIndex');
                self.setMainImg();
            }
        });

        $element.on('click', self.options.prevClass, () => {
            self.setMainImg('prev');
        }).on('click', self.options.nextClass, () => {
            self.setMainImg('next');
        });

        self.setMainImg();
        self.options.mainImg.on('load', () => {
            self.options.loader.hide();
        }).each(function mainImgLoad() {
            if (this.complete) { self.options.mainImg.trigger('load'); } // FIX for Chrome i IE
        });
    }

    let mainImgSrc;
    let galleryPosition;
    let afterImageChangeCallback = () => {};

    // public methods
    self.setMainImg = (nav) => {
        self.options.loader.show();
        if (nav === 'prev') {
            if (self.options.imgIndex > 0) {
                self.options.imgIndex -= 1;
                if ((self.options.imgIndex + 1) % 5 === 0) { $(self.options.carouselPrevID).click(); }
            } else {
                self.options.imgIndex = self.options.images.length - 1;
                $(self.options.carouselPrevID).click();
            }
        } else if (nav === 'next') {
            if (self.options.imgIndex < self.options.images.length - 1) {
                self.options.imgIndex += 1;
                if ((self.options.imgIndex) % 5 === 0) { $(self.options.carouselNextID).click(); }
            } else {
                self.options.imgIndex = 0;
                $(self.options.carouselNextID).click();
            }
        }

        mainImgSrc = self.options.images[self.options.imgIndex].large.src;
        self.options.mainImg.prop('src', mainImgSrc);
        self.options.mainImg.prop('alt', self.options.images[self.options.imgIndex].large.alt);
        self.options.mainImg.prop('title', self.options.images[self.options.imgIndex].large.title);

        self.options.thumbs.removeClass('active');
        $(self.options.thumbs[self.options.imgIndex]).addClass('active');

        galleryPosition = `${self.options.imgIndex + 1}/${self.options.images.length}`;
        self.options.positionCounter.text(galleryPosition);

        if (self.options.images[self.options.imgIndex].itemUrl === undefined) {
            // Kada trenutna slika u nizu nema link, ne želimo da se pojavljuje link sa prijašnje slike
            self.options.largeImageLink.attr('href', '');
            self.options.largeImageLink.text('');
        } else {
            self.options.largeImageLink.attr('href', self.options.images[self.options.imgIndex].itemUrl);
            self.options.largeImageLink.text(self.options.images[self.options.imgIndex].itemTitle);
        }

        afterImageChangeCallback();
    };

    self.goTo = (index) => {
        self.options.imgIndex = index;
        self.setMainImg();

        // FIX: hide loader when you open the same image in inline gallery
        if (self.options.mainImg[0].complete) { self.options.mainImg.trigger('load'); }

        // scroll carousel
        const slide = Math.floor(index / 5);
        // eslint-disable-next-line eqeqeq
        if (typeof ($(self.options.carouselID).data('jcarousel')) != 'undefined') {
            $(self.options.carouselID).data('jcarousel').scroll(slide + 1);
        }
        // eslint-disable-next-line eqeqeq
        if (typeof (window.circles) != 'undefined') {
            window.circles.removeClass('active');
            $(window.circles[slide]).addClass('active');
        }
    };

    self.afterImageChange = (callback) => {
        afterImageChangeCallback = callback;
    };

    init();
};

$.fn.guideGallery = function callGuideGallery(options) {
    return this.each(function () { // eslint-disable-line func-names
        if (undefined == $(this).data('guideGallery')) { // eslint-disable-line eqeqeq
            const self = new $.guideGallery(this, options); // eslint-disable-line new-cap
            $(this).data('guideGallery', self);
        }
    });
};

$.fullGallery = function fullGallery(element, options) {
    const defaults = {
        images: '', // image sources (JSON format)
        externalGallery: '', // external (inline) gallery
        labelAlbum: '', // text label for album name
        labelEsc: '', // text label for close
        labelPrev: '', // text label for previous link
        labelNext: '', // text label for next link
        labelNotification: '', // text label for "gallery begin" notification
        imgIndex: 0, // image position
        cacheImgIndex: 1, // preload image position
        cacheImg: document.createElement('img'), // preloaded next-prev image
    };

    const self = this;
    self.options = {};
    const $element = $(element);

    let leftSpan = '';
    let rightSpan = '';
    function render() {
        if (options.images.length > 1) {
            rightSpan = '<div class="fullNext guideGalleryImageSliderNext big"><span class="right"></span></div>';
            leftSpan = '<div class="fullPrev guideGalleryImageSliderPrevious big"><span class="left"></span>';
        }
        const galleryTemplate = `<a title="${self.options.labelEsc}" id="closeFullScr"></a> \
            <div class="galleryImage">`
            + `<span class="albumLabel">${self.options.labelAlbum} </span><span id="fullPosition" class="galleryImageSliderNumber">1/1</span> \
                <div class="galleryImageLargeContainerNew">${rightSpan}<div class="galleryImageLarge"><img id="fullImage" /></div> \
                    <div id="galleryLoaderBig"></div> \
                    <div id="galleryNotification">${self.options.labelNotification}</div>+${leftSpan}</div> \
                </div> \
            </div>`;

        $element.append(galleryTemplate);

        self.options.loader = $('#galleryLoaderBig');
        self.options.notification = $('#galleryNotification');
        self.options.positionCounter = $('#fullPosition');
        self.options.mainImg = $('#fullImage');

        self.options.mainImg.on('load', () => {
            self.options.loader.hide();
        }).each(function mainImgLoad() {
            if (this.complete) { self.options.mainImg.trigger('load'); } // FIX for Chrome i IE
        });

        $element.on('click', '.fullPrev', () => {
            self.setMainImg('prev');
        }).on('click', '.fullNext', () => {
            self.setMainImg('next');
        });

        $element.find('#closeFullScr').tooltip().click(() => { self.closeFullScr(); });
    }

    // private methods
    const init = () => {
        self.options = $.extend({}, defaults, options);
        window.openedFS = true;

        render();

        self.goTo(self.options.externalGallery.options.imgIndex);
        self.activateKeys();
    };

    let mainImgSrc;
    let galleryPosition;

    // public methods
    self.closeFullScr = () => {
        $('body').removeClass('fullMode');
        $(document).off('.fullScrEvents');
        self.options.externalGallery.goTo(self.options.imgIndex);
    };

    self.activateKeys = () => {
        $(document).on('keydown.fullScrEvents', (e) => {
            // eslint-disable-next-line eqeqeq
            if (e.keyCode == 37) { // left arrow
                e.preventDefault();
                self.options.loader.show();
                self.setMainImg('prev');
            // eslint-disable-next-line eqeqeq
            } else if (e.keyCode == 39) { // right arrow
                e.preventDefault();
                self.options.loader.show();
                self.setMainImg('next');
            }
        }).on('keyup.fullScrEvents', (e) => {
            // eslint-disable-next-line eqeqeq
            if (e.keyCode == 27) { self.closeFullScr(); } // escape
        });
    };

    self.goTo = (index) => {
        self.options.imgIndex = index;
        self.options.cacheImgIndex = index + 1;
        self.setMainImg();

        // FIX: hide loader when you open the same image in inline gallery
        if (self.options.mainImg[0].complete) { self.options.mainImg.trigger('load'); }
    };

    self.setMainImg = (nav) => {
        self.options.loader.show();
        if (nav === 'prev') {
            if (self.options.imgIndex > 0) {
                self.options.imgIndex -= 1;
            } else {
                self.options.notification.hide().stop(true);
                self.options.imgIndex = self.options.images.length - 1;
            }
        } else if (nav === 'next') {
            if (self.options.imgIndex < self.options.images.length - 1) {
                self.options.imgIndex += 1;
            } else {
                // eslint-disable-next-line newline-per-chained-call
                self.options.notification.hide().stop(true).fadeIn().delay(2000).fadeOut();
                self.options.imgIndex = 0;
            }
        }

        mainImgSrc = $(self.options.images).get(self.options.imgIndex).fullscreen.src;
        self.options.mainImg.prop('src', mainImgSrc);

        galleryPosition = `${self.options.imgIndex + 1}/${self.options.images.length}`;
        self.options.positionCounter.text(galleryPosition);

        self.preloadImg(nav);
    };

    self.preloadImg = (nav) => {
        if (nav === 'prev') {
            if (self.options.imgIndex > 0) {
                self.options.cacheImgIndex = self.options.imgIndex - 1;
            } else {
                self.options.cacheImgIndex = self.options.images.length - 1;
            }
        } else if (nav === 'next') {
            if (self.options.imgIndex < self.options.images.length - 1) {
                self.options.cacheImgIndex = self.options.imgIndex + 1;
            } else {
                self.options.cacheImgIndex = 0;
            }
        } else {
            self.options.cacheImgIndex = 0;
        }

        self.options.cacheImg.src = $(self.options.images).get(self.options.cacheImgIndex).fullscreen.src;
    };

    init();
};

$.fn.fullGallery = function callFullGallery(options) {
    return this.each(function () { // eslint-disable-line func-names
        if (undefined == $(this).data('fullGallery')) { // eslint-disable-line eqeqeq
            const self = new $.fullGallery(this, options); // eslint-disable-line new-cap
            $(this).data('fullGallery', self);
        }
    });
};
